import React from 'react';

// import { Container } from './styles';

function Team() {
  return <div />;
}

export default Team;
